import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "./My_Table.css";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import {
  deleteData,
  editStatusData,
  getData,
  getDownloadDataExcel,
  postData,
} from "../../../../utils/api";
import { Link } from "react-router-dom";
import { ApprovalStatus, RoleId, Select2Data } from "../../../../utils/common";
import LinkProductsModel from "../LinkProductsModel";
import { DeletButton } from "../../../common/Button";
import ModalDelete from "../../../common/ModelDelete";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader } from "react-spinners";
import Loader from "../../../common/Loader/Loader";

function My_Table({
  data,
  getDataAll,
  OrderByOptions,
  user,
  reset,
  setonPageChange,
  store_id,
  setStoreId,
  vendors,
  paramid,
  setChangeStatus,
  // sortOrder,
  // setSortOrder,
  resultsPerPageOptions,
  perPage,
  setperPage,
  setReset,
  hideFilter,
  setHideFilter,
  option,
  setStoreCategory,
  childCategories,
  subCategories,
  categories,
  setSearchCategory,
  setSearchSubCategory,
  setSearchChildCategory,
  searchChildCategory,
  searchSubCategory,
  searchCategory,
  getAllSubCategories,
  getAllChildCategories,
  setSearch,
  search,
  searchDateTo,
  searchDateFrom,
  setSearchDateTo,
  setSearchDateFrom,
  setSubCategories,
  setChildCategories,
  HandleDownload,
  HandleDownloadProductOrder,
  loader,
  setLoader,
  loading,
  onPageChange,
  setLoading,
}) {
  const { IMG_URL, ErrorNotify } = useContext(Context);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const [showModel, setShowModel] = useState(0);

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeStoreStatus = async (id, option) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/products/status/${id}`, {
        approval_status_id: option,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/products/${recordToDeleteId}`);
      if (response?.success) {
        getDataAll();
      }

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/products/${id}`);
    setChangeStatus(response);
  };

  const ChangeTopPick = async (id) => {
    const response = await editStatusData(`/admin/products/top-pick/${id}`);
    setChangeStatus(response);
  };

  const ChangeSeasonable = async (id) => {
    const response = await editStatusData(
      `/admin/products/seasonable-status/${id}`,
    );
    setChangeStatus(response);
  };
  const ChangeBestSeller = async (id) => {
    const response = await editStatusData(
      `/admin/products/best-seller-status/${id}`,
    );
    setChangeStatus(response);
  };

  const today = new Date().toISOString().split("T")[0]; // Format today as YYYY-MM-DD
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});

  const handleStartDateChange = (e) => {
    setSearchDateFrom(e.target.value);
    validateDates(e.target.value, searchDateTo);
    setonPageChange(1);
  };

  // Handle End Date change
  const handleEndDateChange = (e) => {
    setSearchDateTo(e.target.value);
    validateDates(searchDateFrom, e.target.value);
    setonPageChange(1);
  };

  // Validate Dates
  const validateDates = (start, end) => {
    let newErrors = {};
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    // Validate Start Date
    if (start && startDateObj > new Date(today)) {
      newErrors.searchDateFrom = "Start date must be today or in the past";
    }

    // Validate End Date
    if (end && endDateObj <= startDateObj) {
      newErrors.searchDateTo = "End date must be greater than start date";
    }

    setErrors(newErrors);
  };

  const [sortBy, setSortBy] = useState("orders"); // "orders" or "price"
  const [sortOrder, setSortOrder] = useState("asc");
  const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
    const totalA = a?.Product_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    const totalB = b?.Product_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    if (sortBy === "price") {
      return sortOrder === "asc" ? totalA - totalB : totalB - totalA;
    } else {
      // fallback: sort by order count
      const countA = a?.Product_Order_Details?.length || 0;
      const countB = b?.Product_Order_Details?.length || 0;
      return sortOrder === "asc" ? countA - countB : countB - countA;
    }
  });

  console.log(sortedData, " data for subcat + ");

  return (
    <section className="pending-table_holder">
      <div className="d-flex align-items-center mb-3 mt-3">
        <div className="show me-2">
          <p className="show m-0">Show</p>
        </div>

        <div className="number me-2">
          <select
            className="form-select form-select-sm"
            aria-label=".form-select-sm example"
            value={perPage}
            onChange={(e) => {
              setonPageChange(1);
              setperPage(Number(e.target.value));
            }}
          >
            {[...new Set(option || [])].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="entries">
          <p className="show m-0">entries</p>
        </div>

        <div className="sowing ms-3 me-2">
          <p className="show m-0">
            Showing{" "}
            {data?.data?.total > 0
              ? ((Number(onPageChange) || 1) - 1) * (Number(perPage) || 5) + 1
              : 0}{" "}
            to{" "}
            {data?.data?.total > 0
              ? Math.min(
                  (Number(onPageChange) || 1) * (Number(perPage) || 5),
                  Number(data?.data?.total) || 0,
                )
              : 0}{" "}
            of {Number(data?.data?.total) || 0} entries
          </p>
        </div>
      </div>

      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end mb-3">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                id=""
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Category </Form.Label>
              <Select
                isSearchable
                options={categories}
                value={searchCategory}
                placeholder="Select Category"
                onChange={(e) => {
                  setSearchCategory(e);
                  getAllSubCategories(e.value);
                  setChildCategories("");
                  setSubCategories("");
                  setSearchSubCategory("");
                  setSearchChildCategory("");
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <Form.Label className="form-label">Start Date</Form.Label>
                <Form.Control
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  max={today}
                  // max="9999-12-31"
                  // min="1900-01-01"
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   const year = value.split("-")[0];

                  //   // Check if year has 4 digits
                  //   if (year.length === 4 || value === "") {
                  //     setSearchDateFrom(value);
                  //     setonPageChange(1);
                  //   }
                  // }}
                  onChange={handleStartDateChange}
                  isInvalid={!!errors.searchDateFrom}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.searchDateFrom}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <Form.Label className="form-label">End Date</Form.Label>
                <Form.Control
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  min={startDate}
                  max={today}
                  // max="9999-12-31"
                  // min="1900-01-01"
                  // onChange={(e) => {
                  //   setSearchDateTo(e.target.value);
                  //   setonPageChange(1);
                  // }}
                  onChange={handleEndDateChange}
                  isInvalid={!!errors.searchDateTo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.searchDateTo}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  Search
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchCategory("");
                    setSearchChildCategory("");
                    setSearchSubCategory("");
                    setErrors("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label>Download Excel</Form.Label>
              <div className="Search-1">
                <button
                  className="btn btn-success "
                  type="button"
                  onClick={HandleDownload}
                >
                  Product Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        {loader ? (
          <>
            <div className="text-center">
              <ClipLoader />
            </div>
          </>
        ) : (
          <Table striped bordered hover className="order-table" responsive>
            <thead>
              <tr>
                <th>Creation Date</th>
                <th>Product details</th>
                {/* <th>Store details</th> */}
                <th>Image</th>
                <th>Categories</th>
                <th>Total Order</th>
                <th>Description</th>

                {/* {user && user?.role_id === RoleId.Vendor && */}
                <th>Status</th>
                {/* } */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={88}>
                    <Loader type="dots" />
                  </td>
                </tr>
              ) : (
                sortedData?.map((item, index) => (
                  <tr key={index}>
                    <td className="order-date">
                      <div className="order-id">
                        {calculateTimeAgo(item?.createdAt)}
                      </div>
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.createdAt)
                              .toISOString()
                              .split("T")[0]
                          }
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{formatTimeInIST(item?.createdAt)} IST</span>
                      </div>
                    </td>

                    {/* Owner Details */}
                    <td className="order-details">
                      {item?.item_code && (
                        <div className="order-id text-highlight">
                          <b>{item?.item_code}</b>
                        </div>
                      )}
                      <div className="order-info">
                        <span className="text-highlight">{item?.name}</span>
                      </div>
                      {/* <div className="order-info">
                    <span>{item?.price} / {item?.Unit?.name}</span>
                  </div> */}

                      {item?.Brand?.name && (
                        <div className="order-info">
                          <div className="order-id">
                            <b>Brand</b>
                          </div>
                          <span>{item?.Brand?.name}</span>
                        </div>
                      )}

                      {item?.manufacturer && (
                        <div className="order-info">
                          <div className="order-id">
                            <b>Manufacturer</b>
                          </div>
                          <span>{item?.manufacturer}</span>
                        </div>
                      )}

                      {item?.tag && (
                        <div className="order-info">
                          <div className="order-id">
                            <b>Tag</b>
                          </div>
                          <span>{item?.tag} </span>
                        </div>
                      )}
                    </td>

                    <td>
                      <img
                        src={IMG_URL + item?.image}
                        alt="Product"
                        className="product-image"
                      />
                    </td>

                    <td className="order-details">
                      {/* <div className="order-info">
                    <span className="text-highlight">{item?.Store_Detail?.store_name}</span>
                  </div> */}

                      {item?.p_category?.name && (
                        <div className="order-info">
                          <strong>Category: </strong>
                          <span>{item?.p_category?.name}</span>
                        </div>
                      )}

                      {item?.p_sub_category?.name && (
                      <div className="order-info">
                        <strong>Sub Category: </strong>
                        <span>{item?.p_sub_category?.name} </span>
                      </div>
                      )}

                      {item?.p_category?.Gender_Category?.name && (
                      <div className="order-info">
                        <strong>Gender Category: </strong>
                        <span>{item?.p_category?.Gender_Category?.name} </span>
                      </div>
                      )}

                      {/* <div className="order-info">
                      <strong>Child Category: </strong>
                      <span>{item?.p_child_category?.name} </span>
                    </div> */}
                      {/* <div className="order-info">
                    <div className="order-id">Manufacturer:</div>
                    <span>{item?.manufacturer} </span>
                  </div> */}
                    </td>

                    <td>
                      <div className="order-info">
                        <span>
                          {" "}
                          <b>No Of order</b>{" "}
                          {item?.Product_Order_Details?.length}{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>
                          <b>Total Price</b>: ₹
                          {item?.Product_Order_Details?.reduce(
                            (sum, detail) => {
                              return sum + Number(detail?.total_amount || 0);
                            },
                            0,
                          ).toFixed(2)}
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="order-info">
                        {/* <span>{item?.description} </span> */}
                        {item?.tax_percentage && (
                          <>
                            <div className="order-id">Tax</div>
                            <span>{item?.tax_percentage} % </span>
                          </>
                        )}
                      </div>
                    </td>

                    {/* <td>
                  {item?.Often_Ordered_Withs?.map((item) => (
                    <div key={item?.id} className="order-info">
                      <span className="text-highlight"> {item?.linked_product?.name}</span>
                    </div>
                  ))}

                  
                  <Button
                    className="action-btn my-1"
                    onClick={() =>
                      setShowModel(item?.id)
                    }
                    style={{ marginTop: "auto" }}
                  >
                    Edit
                  </Button>
                

                </td> */}

                    {/* {user && user?.role_id === RoleId.Vendor && */}
                    <td>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={item?.status}
                            onChange={() => {
                              ChangeStatus(item?.id);
                            }}
                            id={`flexSwitchCheckDefault${item?.id}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexSwitchCheckDefault${item?.id}`}
                          >
                            {item?.status ? "Active" : "Inactive"}
                          </label>
                        </div>

                        {/* <label
                        className="form-check-label"
                        htmlFor={`flexSwitchCheckDefault${item?.id}`}
                      >
                        Recommend for you
                      </label>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          checked={item?.is_replaceble}
                          onChange={() => {
                            ChangeTopPick(item?.id);
                          }}
                          id={`flexSwitchCheckDefault${item?.id}`}
                        />
                      </div> */}

                        {/* <label
                      className="form-check-label"
                      htmlFor={`flexSwitchCheckDefault${item?.id}`}
                    >
                      OUR CHOICE ?
                    </label>
                    
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.seasonable_status}
                        onChange={() => {
                          ChangeSeasonable(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                    </div> */}

                        {/* <label
                          className="form-check-label"
                          htmlFor={`flexSwitchCheckDefault${item?.id}`}
                        >
                          Best Seller ?
                        </label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={item?.best_seller_status}
                            onChange={() => {
                              ChangeBestSeller(item?.id);
                            }}
                            id={`flexSwitchCheckDefault${item?.id}`}
                          />
                        </div> */}
                      </td>
                    </td>
                    {/* } */}

                    <td>
                      {/* {user && user?.role_id === RoleId.Admin &&
                    <select
                      className={item?.approval_status_id === ApprovalStatus.Approved ? "status-holder shipped" : "status-holder Unshipped"}
                      onChange={(e) => ChangeStoreStatus(item?.id, e.target.value)}
                      value={item?.Approval_Status?.id}
                    >
                      <option value={ApprovalStatus.Pending}>Inactive</option>
                      <option value={ApprovalStatus.Approved}>Approved</option>
                      <option value={ApprovalStatus.Rejected}>Rejected</option>
                    </select>
                  } */}

                      {/* {user && user?.role_id === RoleId.Vendor && */}
                      <div className="my-1">
                        <Link to={`/product/edit/${item?.id}`}>
                          <Button className="action-btn active">Edit</Button>
                        </Link>
                        <div className="my-1">
                          <Button
                            className="action-btn "
                            onClick={() =>
                              showDeleteRecord(item?.id, item?.name)
                            }
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                      {/* } */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </div>
      <LinkProductsModel
        user={user}
        show={showModel}
        handleClose={() => {
          setShowModel(0);
          getDataAll();
        }}
      />
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
    </section>
  );
}

export default My_Table;
